
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M11 20a9 9 0 009-9h-2a7 7 0 11-3.903-6.28l1.334-1.556A9 9 0 1011 20zm6.743-12.331a1 1 0 10-1.486-1.338l-5.593 6.214-1.955-1.967a1 1 0 00-1.418 1.41l2.7 2.717a1 1 0 001.452-.036l6.3-7z"}})])
          )
        }
      }
    